"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioGroupItem = RadioGroupItem;
const react_1 = __importDefault(require("react"));
function RadioGroupItem(_a) {
    var { sortNo: _, isItemValid: _1, label, imageUrl, toolTip, onClick } = _a, htmlProps = __rest(_a, ["sortNo", "isItemValid", "label", "imageUrl", "toolTip", "onClick"]);
    return (react_1.default.createElement("div", Object.assign({ onClick: onClick, title: toolTip }, htmlProps),
        imageUrl ? react_1.default.createElement("img", { src: imageUrl }) : undefined,
        label));
}
//# sourceMappingURL=radio-group-item.js.map